module.exports = __webpack_public_path__ + "img/ad-bg.e0bca1ff.jpg";